import { action } from 'typesafe-actions';
import { Types, IFabricationProjectResponse } from './types';

export const loadProjects = (
  contractNumber: string,
  needToLoadContract?: boolean
) =>
  action(Types.LOAD_FABRICATION_PROJECTS, {
    contractNumber,
    needToLoadContract
  });
export const loadProjectsSuccess = (
  projectsResponse: IFabricationProjectResponse
) => action(Types.LOAD_FABRICATION_PROJECTS_SUCCESS, { projectsResponse });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadProjectsFailure = (error: any, contractError?: boolean) =>
  action(Types.LOAD_FABRICATION_PROJECTS_FAILURE, { error, contractError });

export const setNeedToRefreshProjects = () =>
  action(Types.SET_NEED_TO_REFRESH_PROJECTS);
